var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReliability1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 315.74,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.34,
    y: 329.85,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.38,
    y: 147.56,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 161.67,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.89,
    y: 147.56,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 329.85,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 427.41,
    y: 46.74,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 442.18,
    y: 60.85,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 46.11,
    y: 46.74,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.67,
    y: 156.42,
    width: 172.13,
    height: 10.22,
    transform: "translate(731.47 323.06) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.51,
    y: 166.65,
    width: 10.22,
    height: 33.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 428.51,
    y: 166.65,
    width: 10.22,
    height: 10.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.73,
    y: 166.65,
    width: 10.22,
    height: 33.8,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.73,
    y: 166.65,
    width: 10.22,
    height: 10.45,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.52,
    y: 115.65,
    width: 65.14,
    height: 16.4,
    transform: "translate(523.95 -276.24) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.51,
    y: 83.18,
    width: 7.16,
    height: 16.4,
    transform: "translate(491.47 -308.71) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.76,
    y: 97.26,
    width: 2.66,
    height: 16.4,
    transform: "translate(505.55 -294.63) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.49,
    y: 135.08,
    width: 7.16,
    height: 18.45,
    transform: "translate(543.37 -254.77) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 348.17,
    y: 112.7,
    width: 75.98,
    height: 11.46,
    transform: "translate(504.59 -267.73) rotate(90)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.6,
    y: 98.76,
    width: 29.22,
    height: 6.88,
    transform: "translate(488.4 -284.01) rotate(90)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.92,
    y: 119.92,
    width: 75.98,
    height: 11.46,
    transform: "translate(652.89 -16.9) rotate(135.33)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.33,
    y: 126.09,
    width: 29.22,
    height: 6.88,
    transform: "translate(648.82 -7.48) rotate(135.33)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.84,
    y: 117.85,
    width: 57.72,
    height: 19.47,
    transform: "translate(498.28 -243.12) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.01,
    y: 137.89,
    width: 5.38,
    height: 19.47,
    transform: "translate(518.33 -223.07) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369.66,
    y: 130.63,
    width: 2.09,
    height: 19.47,
    transform: "translate(511.07 -230.33) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.9,
    y: 122.59,
    width: 54.24,
    height: 13.45,
    transform: "translate(544.33 -285.7) rotate(90)",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.49,
    y: 141.44,
    width: 5.06,
    height: 13.45,
    transform: "translate(563.18 -266.86) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.49,
    y: 109.18,
    width: 5.06,
    height: 13.45,
    transform: "translate(530.92 -299.11) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.04,
    y: 116.15,
    width: 1.96,
    height: 13.45,
    transform: "translate(537.89 -292.14) rotate(90)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 54.59,
    y: 80.44,
    width: 142.8,
    height: 159.32,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 89.85,
    width: 123.99,
    height: 140.59,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.2,
    y: 114.71,
    width: 43.7,
    height: 51.79,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.63,118.23a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,98.63,118.23Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,125.08c4.42-.34,8.84-.36,13.26-.41s8.84.07,13.25.41c-4.41.34-8.83.36-13.25.41S87.94,125.42,83.52,125.08Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,129.17a63.51,63.51,0,0,1,14.41,0,63.51,63.51,0,0,1-14.41,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,133.27a101.19,101.19,0,0,1,18.42,0c-3.07.32-6.14.39-9.21.41S86.59,133.59,83.52,133.27Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,137.36C87.36,137,91.2,137,95,137s7.68.09,11.52.41c-3.84.32-7.68.39-11.52.41S87.36,137.68,83.52,137.36Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,141.45c3.34-.32,6.67-.39,10-.41s6.67.09,10,.41c-3.34.32-6.67.4-10,.41S86.86,141.77,83.52,141.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,145.54c4.27-.34,8.54-.36,12.81-.41s8.54.07,12.81.41c-4.27.35-8.54.37-12.81.41S87.79,145.88,83.52,145.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,149.64a76.53,76.53,0,0,1,8.28-.42,74,74,0,0,1,8.27.42,83.71,83.71,0,0,1-16.55,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,153.73c4.42-.34,8.84-.36,13.26-.41s8.84.07,13.25.41c-4.41.34-8.83.36-13.25.41S87.94,154.07,83.52,153.73Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.52,157.82c4.42-.34,8.84-.36,13.26-.41s8.84.07,13.25.41c-4.41.34-8.83.36-13.25.41S87.94,158.16,83.52,157.82Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.56,
    y: 147,
    width: 51.71,
    height: 61.28,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153,155.26a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,153,155.26Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,162.28a40.32,40.32,0,0,1,11.47,0,35.77,35.77,0,0,1-5.74.42A36.83,36.83,0,0,1,132.8,162.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,166.9a67.44,67.44,0,0,1,14.85,0,59.7,59.7,0,0,1-7.43.42A61.52,61.52,0,0,1,132.8,166.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,171.52a57.93,57.93,0,0,1,13.76,0,56.56,56.56,0,0,1-13.76,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,176.15a52.84,52.84,0,0,1,6.88-.42,51.34,51.34,0,0,1,6.88.42,57.93,57.93,0,0,1-13.76,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,180.77a40,40,0,0,1,6-.42,38.71,38.71,0,0,1,6,.42,43.74,43.74,0,0,1-11.95,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,185.39a63.26,63.26,0,0,1,7.65-.41,61.28,61.28,0,0,1,7.65.41,71.57,71.57,0,0,1-15.3,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,190a43.14,43.14,0,0,1,6.31-.41,41.71,41.71,0,0,1,6.31.41,48.76,48.76,0,0,1-12.62,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,194.63a67.61,67.61,0,0,1,7.91-.41,65.66,65.66,0,0,1,7.92.41,76.6,76.6,0,0,1-15.83,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.8,199.25a67.61,67.61,0,0,1,7.91-.41,65.66,65.66,0,0,1,7.92.41,76.6,76.6,0,0,1-15.83,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,162.28a69,69,0,0,1,15,0,60.88,60.88,0,0,1-7.51.42A63,63,0,0,1,155.4,162.28Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,166.9a30,30,0,0,1,9.88,0,26.66,26.66,0,0,1-4.94.42A27.39,27.39,0,0,1,155.4,166.9Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,171.52a61.16,61.16,0,0,1,14.14,0,59.72,59.72,0,0,1-14.14,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,176.15a52.84,52.84,0,0,1,6.88-.42,51.09,51.09,0,0,1,6.87.42,57.85,57.85,0,0,1-13.75,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,180.77a63,63,0,0,1,7.51-.42,60.88,60.88,0,0,1,7.51.42,69,69,0,0,1-15,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,185.39a38.65,38.65,0,0,1,6-.41,37.57,37.57,0,0,1,6,.41,43.74,43.74,0,0,1-11.95,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,190a54,54,0,0,1,7.07-.41,52.48,52.48,0,0,1,7.07.41,61.16,61.16,0,0,1-14.14,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,194.63a32.38,32.38,0,0,1,5.46-.41,31.42,31.42,0,0,1,5.47.41,36.63,36.63,0,0,1-10.93,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.4,199.25a29.85,29.85,0,0,1,5.24-.41,29,29,0,0,1,5.25.41,33.75,33.75,0,0,1-10.49,0Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.89,
    y: 100.47,
    width: 26.3,
    height: 26.3,
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.61,103.14a1.57,1.57,0,1,1-1.57-1.57A1.57,1.57,0,0,1,129.61,103.14Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.32,
    y: 89.85,
    width: 3.55,
    height: 140.75,
    style: {
      fill: "#c7c7c7"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.44,377.59c-1.11,1.4-94.47,5.59-98.92,4.32a3.28,3.28,0,0,1-.61-.27c-5.5-2.57-30.95-25.94-32.87-27.91-4.71-4.83,14.79-38.84,21-44.46,4.13-3.74,11.79-5.2,11.79-5.2s21.63-62.4,35-75.46c3.35-3.28,61.24-4.56,71.59.15,4.43,2,15.2,13,15.49,15v0C258.15,246.66,236.56,376.16,235.44,377.59Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,377.59c-1.11,1.4-94.47,5.59-98.92,4.32a3.28,3.28,0,0,1-.61-.27c8.94-24.18,51-137.68,52.19-138.41s56.52-.4,69.77.55C258.15,246.66,236.56,376.16,235.44,377.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.15,233.21c-.93-.88-1.55-13.57.17-16.09,1.92-2.83,24.12-1.43,25.43,1s1.94,15.09,1.27,15.54-4.37.9-4.87.09-.47-11.3-.86-11.85-15.94-1.57-16.47-.77.76,11.41.14,11.87S202.06,234.06,201.15,233.21Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.89,441.4H198.3c-5.76-22-11.05-41.41-14.42-53.67-2.12-7.71-3.48-12.6-3.74-13.52l0-.16h98.36l3,13.79c1.19,5.57,2.7,12.62,4.44,20.67.14.7.3,1.41.45,2.15C288.33,419.87,290.56,430.33,292.89,441.4Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.64,441.4h-1.78c-4.83-17.83-9.59-35.69-14.16-53.59l-.39-1.51a.34.34,0,0,1,.65-.19c.17.57.34,1.13.49,1.7C202.67,405.62,207.69,423.5,212.64,441.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.78,374.21A91.86,91.86,0,0,1,267.42,388c-1.1,3.58-2.42,7.45-3.93,11.44-.32.9-.68,1.79-1,2.69-4.77,12.15-11,24.53-17.44,30.4h0a16.59,16.59,0,0,1-2.47,1.94L237,437.87a.18.18,0,0,1,0,.08h0c-.05.33-.24,1.51-.56,3.44H144.19C141.84,420,146.75,400,151,387.48a110.88,110.88,0,0,1,5.36-13.27Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.82,427.32a172.69,172.69,0,0,1-17.9,8.56c-1.63.71-3.26,1.4-4.92,2.07h0c-.1,0-.2.09-.3.12-1.43.59-2.86,1.15-4.29,1.71s-2.79,1.1-4.2,1.62h-3.13c2.15-1.09,4.41-2,6.59-3,3.05-1.36,6.09-2.71,9.15-4q2.08-.9,4.17-1.84h0c4.77-2.11,9.52-4.23,14.43-6C259.93,426.33,260.25,427.06,259.82,427.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,438c0,.73-.06,1.92-.2,3.39h-1c.32-1.38.62-2.51.89-3.33a.32.32,0,0,1,0-.09.14.14,0,0,1,.27,0h0S237,438,237,438Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.33,380q-1.86,3.74-3.43,7.62a102.56,102.56,0,0,0-7,49.46c.17,1.46.37,2.91.6,4.36h-1.63a100.93,100.93,0,0,1-1.1-12.75,97.21,97.21,0,0,1,8.06-41.09c1.18-2.7,2.49-5.33,3.92-7.91C165,379.3,165.51,379.61,165.33,380Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.71,412.27c.09-3.55.34-7.1.52-10.65.41-8.38.74-16.81,1.52-25.17a.26.26,0,0,1,.52,0c.1,6.48-.15,13-.28,19.46-.06,3.25-.16,6.49-.25,9.74a92.86,92.86,0,0,0-.06,9.29c.17,2.34.69,6.88,3.74,7.16,2.87.27,5.15-2.83,5.86-5.11,1.83-5.77,2.47-12,3.06-18,.35-3.56.76-18,.57-21.62,0-.23.35-.22.36,0,.2,3.66.7,7.3.82,11s.13,7.32-.1,11c-.23,3.5-.52,7-1.05,10.48a37.71,37.71,0,0,1-2.25,9.27c-1.06,2.46-2.88,4.72-5.64,5.26a6,6,0,0,1-1,.11c0,.75-.14,1.51-.19,2.25-.08,1.17-.23,2.34-.38,3.51a28,28,0,0,1-.72,3.39,12.32,12.32,0,0,1-1.2,3.25c-.09.16-.31.07-.33-.1a16.48,16.48,0,0,1,.28-3.35c.16-1.14.32-2.29.55-3.42s.44-2.22.67-3.33c.15-.74.25-1.51.4-2.27a5.48,5.48,0,0,1-4.08-3.2C234.74,418.47,234.64,415.24,234.71,412.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.8,256c10.07,13.77,74.78,73.69,116.41,73.65,7,0,31.45,2.89,37.6-17.71,7.16-24,6.64-74.63-.75-97.87-6.11-19.23-51.12,8.21-51.87,20.06-.57,9,1.16,37.62-.67,37.55-11.9-.49-51.73-22.32-89.06-33C223.16,233.68,221,245.42,228.8,256Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.06,220.51c-3.85-19.23-14.2-39.51-20.22-45s-34.61-15.36-41.52-16.27-31.91,5.07-36.57,9.21c-3.73,3.32,2,12,16.11,11.46,13.18-.46,16.31-1.22,20.06-.44s14.6,10.43,13.33,15.94c-.75,3.24-8.66,8.49-14.52,7.17s-9.16-7.3-16.32-11.05-17.84-.92-17.87,2.13,3.83,3.68,11.4,12.46c4.87,5.65,8,16.54,18.36,25.86,5.19,4.69,17.29,12.09,17.29,12.09Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.23,176.19C354.34,169.07,338,157,323.7,154.67c-9.64-1.6-37.33,19.68-35.23,25.38s7.36,4.64,14.95,2.12c2.76-.92,16.65-9.37,19.85-6.75,4.6,3.77,12.43,18.26,12.43,18.26Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.76,177.6c2.51-7.07,10.18-12.14,17.95-16.5.12-.07.23.12.11.18-2,1.12-14.25,10.12-17.95,16.4C288.83,177.75,288.74,177.67,288.76,177.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.23,176.19C354.34,169.07,338,157,323.7,154.67c-9.64-1.6-30.05,22.56-27.95,28.25s9.75,4.62,17.5,0c2.5-1.49,10.24-9.71,13.44-7.09,4.59,3.77,15.85,13.16,15.85,13.16Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.58,186c3.21-.95,6.4-3.63,8.88-5.82,2.17-1.91,4.4-4.29,7.24-5.15a6.15,6.15,0,0,1,3.84,0,11.8,11.8,0,0,1,3.35,2.35c1.2,1,2.34,2.09,3.45,3.19s1.51,1.49,2.61,2.61c.46.47.1.74-.42.24a42.7,42.7,0,0,0-6.12-4.84,14,14,0,0,0-3.5-2.08,5.19,5.19,0,0,0-4,.55c-2.56,1.38-4.58,3.65-7,5.24s-5.4,3.6-8.29,4C306.47,186.21,306.45,186,306.58,186Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.86,176.59c1.29-3.28,3.77-6.2,6.14-8.75a70.87,70.87,0,0,1,8.17-7.41c1.49-1.16,3-2.3,4.56-3.38s3-2.29,4.73-2.75c4.82-1.25,10.2,1.58,12.3,2.36.13.05.08.26-.05.21-1.73-.61-7.31-2.67-10.33-2a13.22,13.22,0,0,0-5,2.59c-1.32,1-2.64,1.94-3.94,2.94-5.27,4.07-10.6,8.81-14.11,14.55-1.94,3.19-3,7.06-.75,10.36.08.12-.08.23-.18.15C294.9,183.35,294.75,179.43,295.86,176.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.49,192.28c-5.64-11.84-16.16-28.64-20.26-32.93S331.47,140.92,325,143c-8.12,2.62,3.61,15.82,9.22,21.1s7,15.9,7,15.9Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.07,155.13c1.95,1.64,3.76,3.52,5.53,5.34a50.33,50.33,0,0,1,5,5.36,21.84,21.84,0,0,1,3,6.51c.35,1.13.62,2.27.86,3.43s.42,2.57.71,3.82c0,.14-.17.2-.21.07a53.15,53.15,0,0,0-2.31-6.71,29.88,29.88,0,0,0-3.49-6.43c-2.83-4-6.46-7.25-9.33-11.18C325.7,155.19,325.93,155,326.07,155.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.48,245.27,397.68,261s-7.12,54.85-21.48,64.95-49.45,6.12-70.85-7S242.66,278,228.83,257.61s1.48-24.69,16.15-18.67,81.87,30.89,82.59,30.42S328.48,245.27,328.48,245.27Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.52,303.53a3,3,0,0,1-1.2.58,2.4,2.4,0,0,1-2.18-.67,3,3,0,0,0-3.4-.59,3.15,3.15,0,0,0-1.25,1.11c-.28.4-.59.79-.86,1.25a12,12,0,0,0,1.29-.85,3.88,3.88,0,0,1,1.16-.62,2.38,2.38,0,0,1,2.21.59,3.1,3.1,0,0,0,3.34.7,3,3,0,0,0,1.31-1.07c.28-.43.59-.83.83-1.29A13.94,13.94,0,0,0,374.52,303.53Zm-54.95,9.29a2.31,2.31,0,0,1-1.16.58,2.36,2.36,0,0,1-2.21-.64,3,3,0,0,0-3.37-.62,3.3,3.3,0,0,0-1.26,1.11,13,13,0,0,0-.86,1.28,12,12,0,0,0,1.29-.85,2.64,2.64,0,0,1,1.16-.62,2.31,2.31,0,0,1,2.18.59,3.15,3.15,0,0,0,3.37.7,3,3,0,0,0,1.29-1.07c.27-.43.61-.83.86-1.29C320.4,312.24,320,312.54,319.57,312.82Zm27.52-54.22a2.52,2.52,0,0,1-1.16.59,2.3,2.3,0,0,1-2.18-.68,3.11,3.11,0,0,0-3.4-.58,3,3,0,0,0-1.26,1.1c-.27.43-.61.83-.86,1.29.46-.28.86-.58,1.29-.86a2.5,2.5,0,0,1,1.17-.61,2.28,2.28,0,0,1,2.2.55,3,3,0,0,0,4.66-.37c.28-.43.58-.83.83-1.29C347.92,258,347.52,258.33,347.09,258.6Zm-49.46,32.09a14.22,14.22,0,0,0-.31-1.5c-.12.49-.18,1-.31,1.5a3.11,3.11,0,0,1-.36,1.26,2.29,2.29,0,0,1-2,1.13,3.17,3.17,0,0,0-2.88,1.9,3,3,0,0,0-.15,1.69,12.52,12.52,0,0,0,.31,1.5,14.73,14.73,0,0,0,.3-1.5,2.74,2.74,0,0,1,.43-1.26,2.29,2.29,0,0,1,2-1.07,3,3,0,0,0,2.79-2A2.83,2.83,0,0,0,297.63,290.69Zm-6.3-31.54a12.22,12.22,0,0,0-.3-1.51c-.12.49-.19,1-.31,1.51a2.92,2.92,0,0,1-.37,1.25,2.26,2.26,0,0,1-2,1.14,3,3,0,0,0-3,3.55,13.77,13.77,0,0,0,.3,1.53,11.85,11.85,0,0,0,.31-1.53,2.66,2.66,0,0,1,.43-1.22,2.28,2.28,0,0,1,2-1.08,3.13,3.13,0,0,0,2.82-2A2.93,2.93,0,0,0,291.33,259.15Zm84.22,60.93a12.06,12.06,0,0,0-.3-1.5c-.13.49-.19,1-.31,1.5a3,3,0,0,1-.37,1.26,2.28,2.28,0,0,1-2,1.13,3.16,3.16,0,0,0-2.88,1.9,3,3,0,0,0-.15,1.66,13.77,13.77,0,0,0,.3,1.53,11.85,11.85,0,0,0,.31-1.53,2.62,2.62,0,0,1,.43-1.23,2.28,2.28,0,0,1,2-1.07,3,3,0,0,0,2.91-3.65Zm-29.26-32.55a12.06,12.06,0,0,0-.3-1.5c-.12.49-.19,1-.31,1.5a2.92,2.92,0,0,1-.37,1.26,2.23,2.23,0,0,1-2,1.13,3,3,0,0,0-3,3.56,13.77,13.77,0,0,0,.3,1.53,11.85,11.85,0,0,0,.31-1.53,2.74,2.74,0,0,1,.43-1.23,2.29,2.29,0,0,1,2-1.07,3.14,3.14,0,0,0,2.82-2A3,3,0,0,0,346.29,287.53Zm29.26-7.44a3.13,3.13,0,0,1-1.23-.4,2.33,2.33,0,0,1-1.07-2,3.1,3.1,0,0,0-2-2.82,2.82,2.82,0,0,0-1.66-.13c-.52.13-1,.19-1.53.31.52.15,1,.21,1.53.31a3.11,3.11,0,0,1,1.26.36,2.36,2.36,0,0,1,1.13,2,3.14,3.14,0,0,0,1.9,2.88,2.9,2.9,0,0,0,1.66.15,11.85,11.85,0,0,0,1.53-.31C376.56,280.27,376.07,280.21,375.55,280.09ZM349,322.23a3,3,0,0,1-1.25-.43,2.35,2.35,0,0,1-1.08-2,3,3,0,0,0-3.64-2.95c-.53.13-1,.19-1.51.31a13.9,13.9,0,0,0,1.51.31,2.67,2.67,0,0,1,1.25.39,2.34,2.34,0,0,1,1.17,2,3,3,0,0,0,1.87,2.85,3,3,0,0,0,1.68.15,12.52,12.52,0,0,0,1.5-.31C350,322.38,349.48,322.32,349,322.23Zm-30.12-42.14a3.07,3.07,0,0,1-1.26-.4,2.49,2.49,0,0,1-1.07-2,3,3,0,0,0-2-2.82,2.91,2.91,0,0,0-1.68-.13c-.49.1-1,.16-1.5.31.49.15,1,.21,1.5.31a3.41,3.41,0,0,1,1.29.36,2.43,2.43,0,0,1,1.13,2,3.14,3.14,0,0,0,1.87,2.88,3,3,0,0,0,1.69.15,11.42,11.42,0,0,0,1.5-.31C319.88,280.27,319.36,280.21,318.87,280.09ZM260,254.15c-.13-.52-.19-1-.31-1.53-.15.52-.21,1-.31,1.53a3.11,3.11,0,0,1-.36,1.26,2.36,2.36,0,0,1-2,1.13,3.09,3.09,0,0,0-2.88,1.9,2.87,2.87,0,0,0-.15,1.65,10.35,10.35,0,0,0,.31,1.51c.12-.49.18-1,.3-1.51a3.08,3.08,0,0,1,.4-1.22,2.28,2.28,0,0,1,2-1.07,3.11,3.11,0,0,0,2.82-2A2.81,2.81,0,0,0,260,254.15Zm-27-14.71a2.74,2.74,0,0,1-1.26-.43,2.43,2.43,0,0,1-1.07-2,2,2,0,0,0,0-.34c-.42.07-.82.15-1.21.25a.49.49,0,0,1,0,.12,3.14,3.14,0,0,0,1.87,2.88,3,3,0,0,0,1.69.15,11.42,11.42,0,0,0,1.5-.31A13.27,13.27,0,0,0,233.06,239.44Zm34,51.67a2.59,2.59,0,0,1-1.25-.43,2.4,2.4,0,0,1-1.07-2,3.09,3.09,0,0,0-2-2.82,2.93,2.93,0,0,0-1.65-.09,13.27,13.27,0,0,0-1.5.3c.49.13,1,.19,1.5.31a2.88,2.88,0,0,1,1.25.37,2.36,2.36,0,0,1,1.17,2,3.08,3.08,0,0,0,1.87,2.88,3.28,3.28,0,0,0,1.68.15,13.44,13.44,0,0,0,1.51-.3A11.56,11.56,0,0,0,267,291.11Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.35,285.11c-.14-1.79-.18-3.58-.15-5.37a56.73,56.73,0,0,1,1.4-10.29c0-.15.29-.11.28.05-.37,3.39-.4,6.85-.54,10.26-.08,1.69-.12,3.38-.14,5.08s-.1,3.48,0,5.21c0,.1-.17.12-.18,0C326.77,288.41,326.48,286.78,326.35,285.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.37,276.76c-32.62-8.8-56.22-12.8-60.76-13.47a.1.1,0,0,0-.05.19c22.68,6.7,58.55,13.52,60.75,13.68A.21.21,0,0,0,392.37,276.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.18,326.62c-14.95,9.24-48.91,5.14-69.82-7.69-21.4-13.12-62.7-40.94-76.53-61.32-3.65-5.37-5.27-9.63-5.4-12.87Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.26,394.06c.1.12,136.57-6.25,137.46-7.09,1.65-1.57-19.45-108.06-41.54-145.34-4.14-7-22.8-17.29-36.34-4.07C165,277.46,144.54,391.67,146.26,394.06Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68,285.75a2.86,2.86,0,0,1-1.23-.43,2.3,2.3,0,0,1-1.07-2,3,3,0,0,0-3.65-2.91,13.82,13.82,0,0,0-1.53.31c.52.12,1,.18,1.53.28a3.12,3.12,0,0,1,1.26.39,2.36,2.36,0,0,1,1.13,2,3.1,3.1,0,0,0,1.9,2.85,2.92,2.92,0,0,0,1.66.18c.52-.12,1-.18,1.5-.31A12.06,12.06,0,0,0,204.68,285.75Zm27.79,99.36a2.81,2.81,0,0,1-1.25-.43,2.35,2.35,0,0,1-1.08-2,3.06,3.06,0,0,0-2-2.82,3.12,3.12,0,0,0-1.65-.09c-.49.09-1,.16-1.5.28a13.27,13.27,0,0,0,1.5.3,3.17,3.17,0,0,1,1.25.4,2.34,2.34,0,0,1,1.17,2,3,3,0,0,0,1.87,2.85,2.91,2.91,0,0,0,1.68.19c.49-.12,1-.19,1.51-.31C233.45,385.26,233,385.2,232.47,385.11Zm27.71-99.2a4.15,4.15,0,0,0-.61.14c.23.06.46.11.7.15A1.4,1.4,0,0,0,260.18,285.91Zm-27.12-46.47a2.74,2.74,0,0,1-1.26-.43,2.43,2.43,0,0,1-1.07-2,3,3,0,0,0-2-2.79,2.94,2.94,0,0,0-1.69-.13c-.49.1-1,.16-1.5.31.49.12,1,.18,1.5.31a3,3,0,0,1,1.26.37,2.36,2.36,0,0,1,1.16,2,3.14,3.14,0,0,0,1.87,2.88,3,3,0,0,0,1.69.15,11.42,11.42,0,0,0,1.5-.31A13.27,13.27,0,0,0,233.06,239.44ZM165.29,327.3a3.07,3.07,0,0,1-1.25-.39,2.49,2.49,0,0,1-1.07-2,3,3,0,0,0-.77-2l-.5,1.61a1.58,1.58,0,0,1,0,.38,3.13,3.13,0,0,0,1.87,2.88,2.91,2.91,0,0,0,1.68.16,13.49,13.49,0,0,0,1.51-.31C166.31,327.49,165.78,327.43,165.29,327.3Zm30.13,42.14a3.13,3.13,0,0,1-1.26-.42,2.37,2.37,0,0,1-1.07-2,3.07,3.07,0,0,0-2-2.82,3.18,3.18,0,0,0-1.66-.12c-.52.12-1,.18-1.5.31a12.06,12.06,0,0,0,1.5.3,2.68,2.68,0,0,1,1.26.4,2.34,2.34,0,0,1,1.17,2,3,3,0,0,0,1.87,2.85,2.89,2.89,0,0,0,1.68.16,14.85,14.85,0,0,0,1.5-.31C196.4,369.6,195.91,369.54,195.42,369.44Zm24.86-40.94a3,3,0,0,1-1.23-.4,2.32,2.32,0,0,1-1.07-2,3.11,3.11,0,0,0-2-2.82,2.74,2.74,0,0,0-1.66-.12c-.52.12-1,.18-1.53.3a11.85,11.85,0,0,0,1.53.31,3,3,0,0,1,1.26.37,2.34,2.34,0,0,1,1.13,2,3.14,3.14,0,0,0,1.9,2.88,2.9,2.9,0,0,0,1.66.15,13.77,13.77,0,0,0,1.53-.3C221.29,328.68,220.8,328.62,220.28,328.5ZM262,354.61a2.51,2.51,0,0,1-1.23-.43,2.28,2.28,0,0,1-1.07-2,3.11,3.11,0,0,0-2-2.82,3.28,3.28,0,0,0-1.69-.09c-.49.09-1,.15-1.5.27a12.52,12.52,0,0,0,1.5.31,3,3,0,0,1,1.29.4,2.3,2.3,0,0,1,1.13,2,3.09,3.09,0,0,0,1.87,2.85,2.88,2.88,0,0,0,1.69.18c.52-.12,1-.18,1.5-.3A10.49,10.49,0,0,0,262,354.61ZM255.77,323a3.55,3.55,0,0,1-1.17.65,2.39,2.39,0,0,1-2.21-.59,3.1,3.1,0,0,0-3.34-.7,2.81,2.81,0,0,0-1.31,1.07c-.28.43-.59.83-.86,1.29.46-.28.86-.58,1.29-.86a2.94,2.94,0,0,1,1.16-.58,2.46,2.46,0,0,1,2.21.67,3.11,3.11,0,0,0,3.4.59,3.25,3.25,0,0,0,1.26-1.11c.27-.43.58-.82.82-1.28C256.59,322.43,256.2,322.74,255.77,323Zm-51.09-76.55c-.1-.53-.16-1-.28-1.51a13.9,13.9,0,0,0-.31,1.51,3.07,3.07,0,0,1-.39,1.25,2.28,2.28,0,0,1-2,1.14,3.11,3.11,0,0,0-2.85,1.9,3,3,0,0,0-.18,1.68c.12.49.18,1,.31,1.5a14.73,14.73,0,0,0,.3-1.5,2.66,2.66,0,0,1,.43-1.25,2.35,2.35,0,0,1,2-1.08,3,3,0,0,0,2.91-3.64Zm-12,88.29a12.06,12.06,0,0,0-.3-1.5c-.12.49-.19,1-.31,1.5a3,3,0,0,1-.37,1.26,2.28,2.28,0,0,1-2,1.13,3,3,0,0,0-3,3.56,13.77,13.77,0,0,0,.3,1.53,11.85,11.85,0,0,0,.31-1.53,2.62,2.62,0,0,1,.43-1.23,2.28,2.28,0,0,1,2-1.07,3.14,3.14,0,0,0,2.82-2A3,3,0,0,0,192.72,334.75Zm44.84-37.27c-.12-.49-.18-1-.31-1.5a14.73,14.73,0,0,0-.3,1.5,3.07,3.07,0,0,1-.4,1.29,2.29,2.29,0,0,1-2,1.14,3,3,0,0,0-2.85,1.9,2.5,2.5,0,0,0-.15,1.65c.09.52.15,1,.27,1.5a12.07,12.07,0,0,0,.31-1.5,3,3,0,0,1,.43-1.23,2.28,2.28,0,0,1,2-1.07,3.11,3.11,0,0,0,2.82-2A3.66,3.66,0,0,0,237.56,297.48Zm-64.39,89.43c-.12-.52-.18-1-.31-1.5a12.06,12.06,0,0,0-.3,1.5,2.72,2.72,0,0,1-.4,1.26,2.23,2.23,0,0,1-2,1.13,3.12,3.12,0,0,0-2.85,1.9,2.93,2.93,0,0,0-.16,1.69c0,.08,0,.17.05.25l.51,0,.06-.23a2.61,2.61,0,0,1,.4-1.26,2.28,2.28,0,0,1,2-1.07,3.06,3.06,0,0,0,2.82-2A3.18,3.18,0,0,0,173.17,386.91Zm61-117.9a2.74,2.74,0,0,1-1.17.58,2.26,2.26,0,0,1-2.17-.67,3.11,3.11,0,0,0-3.4-.58,3,3,0,0,0-1.26,1.1c-.28.43-.61.83-.86,1.29.46-.28.86-.58,1.29-.86a2.52,2.52,0,0,1,1.16-.61,2.29,2.29,0,0,1,2.21.55,3,3,0,0,0,4.66-.37c.28-.43.58-.83.83-1.29C235,268.43,234.59,268.74,234.16,269Zm-40.64,36.81a2.4,2.4,0,0,1-1.16.58,2.27,2.27,0,0,1-2.18-.67,3.11,3.11,0,0,0-3.4-.58,3,3,0,0,0-1.26,1.1c-.27.43-.61.83-.86,1.29.46-.28.86-.59,1.29-.86a2.5,2.5,0,0,1,1.17-.61,2.28,2.28,0,0,1,2.2.55,3,3,0,0,0,4.66-.37c.28-.43.58-.83.83-1.29C194.35,305.24,194,305.54,193.52,305.82ZM166,360a2.38,2.38,0,0,1-1.17.58,2.33,2.33,0,0,1-2.2-.65,3,3,0,0,0-3.37-.61,3.37,3.37,0,0,0-1.26,1.1,12,12,0,0,0-.86,1.29,10.71,10.71,0,0,0,1.29-.86,2.62,2.62,0,0,1,1.16-.61,2.33,2.33,0,0,1,2.18.58,3,3,0,0,0,4.66-.36c.27-.43.61-.83.86-1.29C166.83,359.45,166.43,359.76,166,360Zm65.19-5.55a2.84,2.84,0,0,1-1.2.58,2.37,2.37,0,0,1-2.17-.67,3,3,0,0,0-3.41-.59,3.15,3.15,0,0,0-1.25,1.11c-.28.4-.58.79-.86,1.25a12,12,0,0,0,1.29-.85,4,4,0,0,1,1.16-.62,2.38,2.38,0,0,1,2.21.59,3,3,0,0,0,4.66-.37c.27-.43.58-.83.82-1.29C232,353.88,231.62,354.18,231.19,354.49Zm36.65,22.43a2.94,2.94,0,0,1-1.16.58,2.42,2.42,0,0,1-2.21-.67,3.06,3.06,0,0,0-3.37-.58,2.8,2.8,0,0,0-1.26,1.1,13.77,13.77,0,0,0-.86,1.29c.46-.28.86-.58,1.29-.86a2.89,2.89,0,0,1,1.17-.64,2.29,2.29,0,0,1,2.17.58,3.13,3.13,0,0,0,3.37.7,3,3,0,0,0,1.29-1.07c.28-.43.61-.83.86-1.29C268.67,376.34,268.27,376.65,267.84,376.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.57,
    y: 317.13,
    width: 112.17,
    height: 21.48,
    transform: "matrix(-0.14, 0.99, -0.99, -0.14, 604.82, 127.74)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.85,
    y: 320.03,
    width: 112.17,
    height: 21.48,
    transform: "matrix(-0.14, 0.99, -0.99, -0.14, 631.85, 109.94)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 236.17,
    y: 355.74,
    width: 10.45,
    height: 21.48,
    transform: "translate(637.11 176.77) rotate(97.76)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.27,
    y: 341.75,
    width: 4.05,
    height: 21.48,
    transform: "translate(625.41 159.01) rotate(97.76)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.79,
    y: 320.52,
    width: 120.53,
    height: 19.36,
    transform: "translate(639.37 102.25) rotate(97.76)",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.52,
    y: 274.04,
    width: 11.72,
    height: 19.36,
    transform: "translate(600.5 43.22) rotate(97.76)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.23,
    y: 286.58,
    width: 4.89,
    height: 19.36,
    transform: "matrix(-0.14, 0.99, -0.99, -0.14, 610.98, 59.14)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.83,
    y: 359.9,
    width: 11.72,
    height: 19.36,
    transform: "translate(672.29 152.26) rotate(97.76)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.47,
    y: 273.71,
    width: 36.59,
    height: 120.64,
    transform: "translate(47.87 -37.82) rotate(7.76)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.6,
    y: 328.08,
    width: 111.27,
    height: 16.09,
    transform: "translate(670.42 86.98) rotate(97.76)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.59,
    y: 324.1,
    width: 111.27,
    height: 30.32,
    transform: "translate(699.61 67.76) rotate(97.76)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.6,
    y: 329.75,
    width: 111.27,
    height: 12.75,
    transform: "translate(670.42 86.98) rotate(97.76)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "307.5 288.64 305.86 301.54 304.15 314.44 300.72 340.23 297.12 366 295.32 378.88 293.45 391.76 295.08 378.85 296.79 365.95 300.23 340.16 303.82 314.39 305.62 301.51 307.5 288.64",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305.02 288.3 303.38 301.21 301.67 314.1 298.24 339.89 294.65 365.66 292.85 378.55 290.97 391.42 292.6 378.51 294.32 365.62 297.75 339.82 301.34 314.06 303.14 301.17 305.02 288.3",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "302.54 287.96 300.9 300.87 299.19 313.76 295.76 339.56 292.17 365.32 290.37 378.21 288.49 391.08 290.13 378.17 291.84 365.28 295.27 339.49 298.86 313.72 300.66 300.83 302.54 287.96",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.06 287.62 298.43 300.53 296.71 313.43 293.29 339.22 289.69 364.99 287.89 377.87 286.01 390.74 287.65 377.84 289.36 364.94 292.79 339.15 296.39 313.38 298.19 300.5 300.06 287.62",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.73,237.8c-1.68-2,9.16-8,12-5.74s17.07,37.45,12.44,75.62S150.57,387,147.77,381.26c-1.17-2.4.33-9.09,2.18-11.23,2.6-3,57.43-36.13,62.85-59.8C217.61,289.18,211,243,206.73,237.8Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.79,264.83c-23.11,55.79-44,134.11-21.09,144.91,15.22,7.17,45.52-50.36,45.81-51.41,1-3.59,1.68-50.11,2.78-92.67C216.3,226.34,198.11,239.91,187.79,264.83Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.68,285.75a2.86,2.86,0,0,1-1.23-.43,2.3,2.3,0,0,1-1.07-2,3,3,0,0,0-3.65-2.91,13.82,13.82,0,0,0-1.53.31c.52.12,1,.18,1.53.28a3.12,3.12,0,0,1,1.26.39,2.36,2.36,0,0,1,1.13,2,3.1,3.1,0,0,0,1.9,2.85,2.92,2.92,0,0,0,1.66.18c.52-.12,1-.18,1.5-.31A12.06,12.06,0,0,0,204.68,285.75ZM166.2,327.49a2.86,2.86,0,0,1-.07.28,5,5,0,0,0,.67-.16A5.79,5.79,0,0,0,166.2,327.49Zm29.22,41.95a3.13,3.13,0,0,1-1.26-.42,2.37,2.37,0,0,1-1.07-2,3.07,3.07,0,0,0-2-2.82,3.18,3.18,0,0,0-1.66-.12c-.52.12-1,.18-1.5.31a12.06,12.06,0,0,0,1.5.3,2.68,2.68,0,0,1,1.26.4,2.34,2.34,0,0,1,1.17,2,3,3,0,0,0,1.87,2.85,2.89,2.89,0,0,0,1.68.16,14.85,14.85,0,0,0,1.5-.31C196.4,369.6,195.91,369.54,195.42,369.44Zm17.38-46a10,10,0,0,0,1.13.25c0-.15,0-.31,0-.47C213.56,323.29,213.19,323.35,212.8,323.44Zm-8.12-77c-.1-.53-.16-1-.28-1.51a13.9,13.9,0,0,0-.31,1.51,3.07,3.07,0,0,1-.39,1.25,2.28,2.28,0,0,1-2,1.14,3.11,3.11,0,0,0-2.85,1.9,3,3,0,0,0-.18,1.68c.12.49.18,1,.31,1.5a14.73,14.73,0,0,0,.3-1.5,2.66,2.66,0,0,1,.43-1.25,2.35,2.35,0,0,1,2-1.08,3,3,0,0,0,2.91-3.64Zm-12,88.29a12.06,12.06,0,0,0-.3-1.5c-.12.49-.19,1-.31,1.5a3,3,0,0,1-.37,1.26,2.28,2.28,0,0,1-2,1.13,3,3,0,0,0-3,3.56,13.77,13.77,0,0,0,.3,1.53,11.85,11.85,0,0,0,.31-1.53,2.62,2.62,0,0,1,.43-1.23,2.28,2.28,0,0,1,2-1.07,3.14,3.14,0,0,0,2.82-2A3,3,0,0,0,192.72,334.75Zm-19.55,52.16c-.12-.52-.18-1-.31-1.5a12.06,12.06,0,0,0-.3,1.5,2.72,2.72,0,0,1-.4,1.26,2.23,2.23,0,0,1-2,1.13,3.12,3.12,0,0,0-2.85,1.9,2.93,2.93,0,0,0-.16,1.69c.1.49.16,1,.31,1.5.12-.52.18-1,.31-1.5a2.61,2.61,0,0,1,.4-1.26,2.28,2.28,0,0,1,2-1.07,3.06,3.06,0,0,0,2.82-2A3.18,3.18,0,0,0,173.17,386.91Zm20.35-81.09a2.4,2.4,0,0,1-1.16.58,2.27,2.27,0,0,1-2.18-.67,3.11,3.11,0,0,0-3.4-.58,3,3,0,0,0-1.26,1.1c-.27.43-.61.83-.86,1.29.46-.28.86-.59,1.29-.86a2.5,2.5,0,0,1,1.17-.61,2.28,2.28,0,0,1,2.2.55,3,3,0,0,0,4.66-.37c.28-.43.58-.83.83-1.29C194.35,305.24,194,305.54,193.52,305.82ZM166,360a2.38,2.38,0,0,1-1.17.58,2.33,2.33,0,0,1-2.2-.65,3,3,0,0,0-3.37-.61.94.94,0,0,0-.22.12c-.07.37-.13.74-.19,1.11a2.09,2.09,0,0,1,.74-.31,2.33,2.33,0,0,1,2.18.58,3,3,0,0,0,4.66-.36c.27-.43.61-.83.86-1.29C166.83,359.45,166.43,359.76,166,360Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217,298.29c-.34,2.55-.66,5.12-.92,7.68,0-.63,0-1.26-.06-1.89-.23-5.15-.5-10.3-.77-15.44,0-.11-.18-.09-.18,0-.1,9.13-.28,18.25-.4,27.38s-.24,18.19-.81,27.3c-.32,5.16-.64,10.37-1.36,15.51,0,.11.16.14.18,0,.74-4.54,1.54-9.06,2-13.62s.94-9.07,1.17-13.61q.54-10.29.34-20.54a119.84,119.84,0,0,0,1.07-12.8C217.34,298.14,217.05,298.13,217,298.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,279.05q-3,7.35-5.88,14.79c.4-2.29.89-4.55,1.37-6.81,0-.15-.2-.24-.26-.09a34.11,34.11,0,0,0-1.79,8.69c-3.34,8.86-6.43,17.81-9.14,26.88-4.38,14.66-7.85,29.69-9.22,44.94a125.51,125.51,0,0,0,0,25.49.11.11,0,0,0,.22,0,215.31,215.31,0,0,1,.9-22.85,210.17,210.17,0,0,1,3.45-22.45,370,370,0,0,1,12.5-43.92c2.78-8.16,5.57-16.31,8.27-24.49C182.52,278.94,182.07,278.79,182,279.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163,406c16,16.66,82.45,10.21,125-1,8.11-2.14-15.47-74.43-23.81-71.17C216.53,352.36,145.38,387.72,163,406Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.6,333.33c-.34,8-5.23,6.91-5.23,6.91s4.58,3.13,5.63,8.35c1.21,6-7.64,10.49-7.64,10.49a18.28,18.28,0,0,1,4.54,9.76c.58,5.83-7.7,11.66-7.7,11.66s1.59,5.88-1.42,11.09c-5.14,8.9-53,16.93-65.87,17.61l-12.09-71.94s43.54-23.08,55.34-21.95C322.1,316.27,347.13,321.08,346.6,333.33Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.22,340c-10.33-3.55-21.48-4.63-32.26-5.54a.19.19,0,0,0,0,.37c10.73.79,21.51,4.46,32.18,5.67A.26.26,0,0,0,341.22,340Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.11,358.26a27.84,27.84,0,0,0-7.4-.77c-2.64-.1-5.28-.14-7.91-.15-5.29,0-10.57.1-15.84.37-.24,0-.28.37,0,.37,5.26,0,10.53.12,15.78.36q4,.18,7.9.43a34.37,34.37,0,0,0,7.45.11A.38.38,0,0,0,339.11,358.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336,380.49c-2-.72-4.59-.37-6.71-.33q-3.6.06-7.22.09c-4.81,0-9.62.07-14.43-.06-.24,0-.27.37,0,.37,4.89.16,9.77.39,14.66.5q3.6.09,7.2.13c2.05,0,4.59.29,6.54-.45A.14.14,0,0,0,336,380.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.23,333.3l13.18,80.49S168.17,427.5,160.18,402.38,259.23,333.3,259.23,333.3Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.47,385.11a2.81,2.81,0,0,1-1.25-.43,2.35,2.35,0,0,1-1.08-2,3.06,3.06,0,0,0-2-2.82,3.12,3.12,0,0,0-1.65-.09c-.49.09-1,.16-1.5.28a13.27,13.27,0,0,0,1.5.3,3.17,3.17,0,0,1,1.25.4,2.34,2.34,0,0,1,1.17,2,3,3,0,0,0,1.87,2.85,2.91,2.91,0,0,0,1.68.19c.49-.12,1-.19,1.51-.31C233.45,385.26,233,385.2,232.47,385.11Zm25,24.57a3,3,0,0,1-1.25-.39,2.39,2.39,0,0,1-1.08-2,3.07,3.07,0,0,0-2-2.82,2.87,2.87,0,0,0-1.65-.12c-.49.12-1,.19-1.51.31a13.44,13.44,0,0,0,1.51.3,3.23,3.23,0,0,1,1.25.37,2.37,2.37,0,0,1,1.17,2,3,3,0,0,0,1.87,2.88,2.89,2.89,0,0,0,1.68.16A14.85,14.85,0,0,0,259,410C258.46,409.87,258,409.81,257.48,409.68Zm-62.06-40.24a3.13,3.13,0,0,1-1.26-.42,2.37,2.37,0,0,1-1.07-2,2.82,2.82,0,0,0-.08-.65l-1.14.7a3,3,0,0,0,1.87,2.83,2.89,2.89,0,0,0,1.68.16,14.85,14.85,0,0,0,1.5-.31C196.4,369.6,195.91,369.54,195.42,369.44Zm67.32-14.7-.78-.13a2.51,2.51,0,0,1-1.23-.43,2.28,2.28,0,0,1-1.07-2,3.11,3.11,0,0,0-2-2.82,3.28,3.28,0,0,0-1.69-.09c-.49.09-1,.15-1.5.27a12.52,12.52,0,0,0,1.5.31,3,3,0,0,1,1.29.4,2.3,2.3,0,0,1,1.13,2,3.09,3.09,0,0,0,1.87,2.85,2.88,2.88,0,0,0,1.69.18c.28-.07.56-.11.83-.16Zm-35.23,54.09a10.49,10.49,0,0,0-.31-1.5c-.12.49-.18,1-.3,1.5a3.17,3.17,0,0,1-.37,1.25,2.28,2.28,0,0,1-2,1.14,3.13,3.13,0,0,0-2.88,1.9,2.79,2.79,0,0,0-.16,1.65,13.82,13.82,0,0,0,.31,1.53c.15-.52.21-1,.31-1.53a2.55,2.55,0,0,1,.43-1.22,2.26,2.26,0,0,1,2-1.08,3.06,3.06,0,0,0,2.79-2A2.87,2.87,0,0,0,227.51,408.83Zm-54.34-21.92c-.12-.52-.18-1-.31-1.5a12.06,12.06,0,0,0-.3,1.5,2.72,2.72,0,0,1-.4,1.26,2.23,2.23,0,0,1-2,1.13,3.12,3.12,0,0,0-2.85,1.9,2.93,2.93,0,0,0-.16,1.69c.1.49.16,1,.31,1.5.12-.52.18-1,.31-1.5a2.61,2.61,0,0,1,.4-1.26,2.28,2.28,0,0,1,2-1.07,3.06,3.06,0,0,0,2.82-2A3.18,3.18,0,0,0,173.17,386.91Zm58-32.42a2.84,2.84,0,0,1-1.2.58,2.37,2.37,0,0,1-2.17-.67,3,3,0,0,0-3.41-.59,3.15,3.15,0,0,0-1.25,1.11c-.28.4-.58.79-.86,1.25a12,12,0,0,0,1.29-.85,4,4,0,0,1,1.16-.62,2.38,2.38,0,0,1,2.21.59,3,3,0,0,0,4.66-.37c.27-.43.58-.83.82-1.29C232,353.88,231.62,354.18,231.19,354.49Zm35.28,23a2.4,2.4,0,0,1-2-.7,3.06,3.06,0,0,0-3.37-.58,2.8,2.8,0,0,0-1.26,1.1,13.77,13.77,0,0,0-.86,1.29c.46-.28.86-.58,1.29-.86a2.89,2.89,0,0,1,1.17-.64,2.29,2.29,0,0,1,2.17.58,3.17,3.17,0,0,0,3,.82ZM206.18,394a3,3,0,0,1-1.2.59,2.39,2.39,0,0,1-2.17-.68,3.06,3.06,0,0,0-3.4-.58,3,3,0,0,0-1.26,1.1c-.28.43-.58.83-.86,1.26.46-.25.86-.55,1.29-.83a3.06,3.06,0,0,1,1.16-.64,2.38,2.38,0,0,1,2.21.58,3.09,3.09,0,0,0,3.34.7,3.28,3.28,0,0,0,1.32-1.07c.27-.43.58-.83.83-1.29C207,393.35,206.61,393.69,206.18,394Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.59,344.91c2.53,35,6.68,59.55,7.59,64.23a.1.1,0,0,0,.2,0c-1.19-24.56-6.78-62.08-7.38-64.29C245.93,344.59,245.57,344.69,245.59,344.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.43,335.43c-.29-.93-.78-3.56-1.23-3.39-1.57.61-3.18,1.09-4.75,1.7L250,335.52q-4.53,1.86-9,3.88-8.9,4-17.55,8.43t-17,9.41c-5.57,3.28-11.09,6.7-16.39,10.39l-1,.7a37.39,37.39,0,0,0-6.59,1.94c-2.48,1-4.86,2.18-7.23,3.41a.09.09,0,0,0,.08.16,53.11,53.11,0,0,1,7.4-2.86l4.55-1.39c-5.05,3.55-10.06,7.17-14.84,11.07-.09.08,0,.2.12.14,5.41-3.67,10.78-7.42,16.33-10.89s11-6.86,16.61-10.11c11.16-6.46,22.58-12.46,34.31-17.84q4.91-2.26,9.88-4.37c1.69-.71,3.39-1.44,5.09-2.14,1.46-.6,2.58-1.14,4-1.74.23.67.44,1.27.66,1.94S260.7,336.27,260.43,335.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.12,190.83c-2.61,5-5.34,9.75-2.42,16.94,2.06,5.07,8.89,10.07,8.89,10.07l8.48-2.14s3.58-6.86,2.64-13.83c-1-7.42-8.59-12.89-8.59-12.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.7,216.68c-1.87,5.37-3.9,10.41,0,17.12,2.76,4.72,10.23,8.7,10.23,8.7l8.09-3.32s2.57-7.29.65-14.07c-2-7.2-10.33-11.54-10.33-11.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.61,241.72c.19,5.68.1,11.12,6.16,16,4.28,3.41,12.67,4.44,12.67,4.44l6.36-6s-.22-7.73-4.45-13.36c-4.48-6-13.78-7.06-13.78-7.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.44,262.13s-1.18,9.77,6.71,16,27.78,2.43,27.78,2.43-6.74-2.44-9.37-8S321,255.94,308.8,256.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.37,
    y: 257.88,
    width: 16,
    height: 5.12,
    transform: "translate(-94.86 287.06) rotate(-44.16)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.73,231c-12.51,5.47-6.08,21.92.48,30,7.4,9.05,19.88,14.6,23.77,12.69s-.31-13.85-.31-13.85,7.88,8.82,10.67,7.83-.36-17.42-8-25.77C234.08,232.77,223,227.82,215.73,231Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.38,238.16c1.28,2.28,11.67,19.74,23.31,19.83,3.79,0,4.86-20.67,4.86-20.67l.42-1.51,6-21.14-27.76-19.85S213.19,234.27,215.38,238.16Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.87,205.52a74.45,74.45,0,0,0,2,7.69c5.29,17.13,15.16,22.22,21.87,23.62l.28-1,6-21.13-27.77-19.85S221.14,199.36,219.87,205.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.41,196.53c-3.89,4.15-7.79,7.93-6.94,15.64.61,5.45,5.81,12.11,5.81,12.11l8.75.25s5.31-5.62,6.3-12.59c1.06-7.41-4.75-14.74-4.75-14.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.71,223.2c-3.26,4.66-6.59,9-4.65,16.47,1.37,5.3,7.47,11.16,7.47,11.16l8.69-1s4.46-6.32,4.46-13.36c0-7.48-6.8-13.92-6.8-13.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.43,250c-1.37,5.52-2.93,10.73,1.58,17,3.19,4.45,11,7.73,11,7.73l7.75-4.05s1.89-7.5-.65-14.07c-2.68-7-11.34-10.54-11.34-10.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226,274.76s-3.8,9.07,2.09,17.24,26.07,9.9,26.07,9.9-5.82-4.18-6.83-10.28-1.84-17.78-13.58-20.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 222.23,
    y: 271.63,
    width: 16,
    height: 5.12,
    transform: "translate(-102.65 142.36) rotate(-28.37)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.36,180.21c5.83,39.29-17.05,47.22-25.52,48.47-7.7,1.13-34,4-43.89-34.47s6.56-53.61,24-57.13S278.53,140.92,284.36,180.21Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.31,174.24a23.9,23.9,0,0,1-2.81-.3,4.56,4.56,0,0,1-2.81-.85,1.45,1.45,0,0,1-.18-1.77,3.6,3.6,0,0,1,3.46-1.2,5.28,5.28,0,0,1,3.5,1.53A1.55,1.55,0,0,1,273.31,174.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.89,177.05a25.49,25.49,0,0,0,2.69-.86,4.51,4.51,0,0,0,2.58-1.4A1.45,1.45,0,0,0,251,173a3.6,3.6,0,0,0-3.63-.48,5.33,5.33,0,0,0-3.13,2.2A1.56,1.56,0,0,0,245.89,177.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.75,182.56c-4.5.22-3.73,9.19.44,9S253.52,182.37,249.75,182.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,183.18c-.74.58-1.43,1.54-2.37,1.71-1.09.2-2-.66-2.78-1.51-.09-.08-.16,0-.15.12.12,1.72.94,3.43,2.8,3.53,1.7.09,2.78-1.54,3.06-3.3C248.64,183.4,248.32,183,248,183.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.64,180.05c4.45-.69,5.5,8.26,1.38,8.89S266.91,180.63,270.64,180.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.57,180.42c.77.39,1.57,1.17,2.42,1.13s1.59-1.11,2.11-2.11c0-.1.13,0,.15.08.25,1.71-.11,3.55-1.71,4.08s-2.74-.87-3.35-2.52C272.08,180.77,272.27,180.26,272.57,180.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,206.62c.69.63,1.39,1.5,2.41,1.54a7.3,7.3,0,0,0,3-.82c.08,0,.18.06.12.14a3.75,3.75,0,0,1-3.47,1.66,3,3,0,0,1-2.29-2.38C255.73,206.6,255.94,206.53,256,206.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.67,195.45s1,4.09,1.17,6.05c0,.18-.45.32-1.11.42,0,0-.05,0-.08,0a9.35,9.35,0,0,1-9.37-2.59.21.21,0,0,1,.27-.3,14.07,14.07,0,0,0,8.73,1.6c.08-.55-1.91-7-1.6-7,1.32.09,3.67.44,4.54.57-.57-2.67-2.58-10.18-3.62-15.05-.06-.3.4-.45.5-.17a131.75,131.75,0,0,1,5.29,16.7C271.5,196.13,267.49,195.71,266.67,195.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.43,200.43a11.49,11.49,0,0,1-3.73,4.43,5.11,5.11,0,0,1-3,.85c-2.33-.11-2.82-2.12-2.79-3.94a12.16,12.16,0,0,1,.42-2.87A14.83,14.83,0,0,0,266.43,200.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.7,204.86a5.11,5.11,0,0,1-3,.85c-2.33-.11-2.82-2.12-2.79-3.94C259.31,201.5,262,202.6,262.7,204.86Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.54,192.55c7.39.84,9.08-16.09,9.08-16.09s31.39-5.71,33.74-31.35c0,0,5.59,16.26,22.15,23.45,0,0,1.5-31.27-23.76-33.25,0,0-31.47-8.79-46.73,13.32S212.58,192,217.54,192.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.45,143.22a27.74,27.74,0,0,1-1.26,11.7,29.13,29.13,0,0,1-5.81,10.42,28.39,28.39,0,0,1-2.1,2.15l-1.08,1c-.38.32-.78.62-1.19.92-.81.58-1.59,1.2-2.42,1.76s-1.73,1-2.61,1.45c-.44.23-.86.48-1.31.69l-1.38.55-2.75,1.1c-1.89.55-3.81,1-5.72,1.43,1.8-.81,3.64-1.43,5.4-2.24l2.59-1.3,1.29-.64c.41-.25.8-.53,1.21-.79.8-.53,1.6-1.05,2.41-1.55s1.49-1.19,2.24-1.78l1.11-.89,1-1a22.42,22.42,0,0,0,2-2.06,33.2,33.2,0,0,0,5.87-9.7,37.84,37.84,0,0,0,2.55-11.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 232.49,
    cy: 196.74,
    r: 0.61,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.46,195.05a.62.62,0,1,1-.62-.61A.61.61,0,0,1,243.46,195.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.54,194.84a.61.61,0,1,1-.61-.61A.61.61,0,0,1,250.54,194.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.55,199.82a.62.62,0,1,1-.62-.61A.61.61,0,0,1,253.55,199.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.43,201.1a.61.61,0,1,1-1.22,0,.61.61,0,1,1,1.22,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.39,201.71a.62.62,0,0,1-.61.62.62.62,0,1,1,.61-.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.82,192a.62.62,0,1,1-.61-.61A.61.61,0,0,1,237.82,192Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.21,194.19a.61.61,0,1,1-.61-.61A.61.61,0,0,1,273.21,194.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282,191.11a.61.61,0,1,1-.61-.61A.61.61,0,0,1,282,191.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.37,187.92a.61.61,0,0,1-1.22,0,.61.61,0,1,1,1.22,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.65,196.1a.61.61,0,1,1-.61-.61A.61.61,0,0,1,279.65,196.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,194.84a.61.61,0,1,1-.61-.61A.61.61,0,0,1,284,194.84Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.89,189.91a.61.61,0,1,1-.61-.62A.61.61,0,0,1,275.89,189.91Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.53,201.73a14.29,14.29,0,1,1,13.82-17.84h0a14.3,14.3,0,0,1-13.82,17.84Zm0-26.68a12.38,12.38,0,1,0,12,9.31A12.33,12.33,0,0,0,247.49,175.05Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.84,197.68c-5.47,0-10.44-5.58-11.32-13a17,17,0,0,1,1.82-10.28,8.9,8.9,0,0,1,15.13-1.8,17.07,17.07,0,0,1,4.18,9.57c.93,7.82-3,14.75-8.88,15.45C279.46,197.66,279.15,197.68,278.84,197.68Zm-1.49-26.58a6,6,0,0,0-.73,0,7.63,7.63,0,0,0-5.62,4.21,15.21,15.21,0,0,0-1.59,9.12c.81,6.77,5.34,11.83,10.14,11.26s8-6.55,7.2-13.33a15.11,15.11,0,0,0-3.68-8.49A7.9,7.9,0,0,0,277.35,171.1Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.21,185.57,260,184.46c1.63-1.74,5.58-4.29,8.88-1.51l-1,1.23C264.93,181.69,261.36,185.41,261.21,185.57Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.84,195.53l-1.51-.56c.26-.71,2.68-6.9,6.18-7.91,3.28-.93,25-1.47,25.88-1.49l0,1.61c-6.21.15-22.94.71-25.47,1.43C206.64,189.27,204.48,193.83,203.84,195.53Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.85,193.66s-9.71-12.22-15.31-8.69,2.24,21.64,9.2,23.75a6.93,6.93,0,0,0,9-4.28Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.92,190.1a.1.1,0,0,0,0,.19c4.89,1.64,7.67,5.91,9.71,10.39-1.53-1.68-3.52-2.53-5.78-.7-.12.1,0,.28.14.25a4.26,4.26,0,0,1,4.78,1.2,20.71,20.71,0,0,1,2.47,3.65c.25.41,1,.14.81-.34,0,0,0-.08,0-.11C221.73,198.54,216.48,190.32,209.92,190.1Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M89.7,350.94c-15,14.69-17.52,37.43-14.36,57.34.08.45.78.33.78-.1,0-4.53-.14-9-.12-13.5l.23-.6c3.92-2.85,7.52-6.07,9.75-10.48,2.51-4.93,3.49-10.49,5.41-15.64.18-.49-.35-.35-.69-.09-9.13,6.73-12,14-14.66,23.66a79.63,79.63,0,0,1,1.59-15.08c2-9.19,5.87-18.29,12.47-25.11C90.35,351.08,90,350.68,89.7,350.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.53,352.65c2.58.09,4.2,4.22,6.21,5.42a1.94,1.94,0,0,0,2.85-.45c2-2.78-.74-6.21-3.32-8.13,1.84.75,3.37,2.08,5.35,2.46A1.87,1.87,0,0,0,106,350.5c.87-3.79-3.89-5.48-7.15-5.56,1.58-1.1,6.12-4.09,3.71-5.56s-7.77,2.8-9.51,4.21c-2.55,2.07-5.59,5.16-5.71,8.4C87.23,355.77,90.54,353.45,92.53,352.65Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.53,352.65c2.58.09,4.2,4.22,6.21,5.42a1.94,1.94,0,0,0,2.85-.45c2-2.78-.74-6.21-3.32-8.13,1.84.75,3.37,2.08,5.35,2.46A1.87,1.87,0,0,0,106,350.5c.87-3.79-3.89-5.48-7.15-5.56,1.58-1.1,6.12-4.09,3.71-5.56s-7.77,2.8-9.51,4.21c-2.55,2.07-5.59,5.16-5.71,8.4C87.23,355.77,90.54,353.45,92.53,352.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.78,353.29c3.3-1.5,9.64.66,10.18-.59,1.09-2.54-4-4.29-6.71-4.63,2.52-.68,7.35-1.77,7.2-4.19-.18-3-7.41-.42-11.06,2.38-4.61,3.53-4.58,6.94-3.82,7.62C88.62,354.82,91.23,353.54,91.78,353.29Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.78,353.29c3.3-1.5,9.64.66,10.18-.59,1.09-2.54-4-4.29-6.71-4.63,2.52-.68,7.35-1.77,7.2-4.19-.18-3-7.41-.42-11.06,2.38-4.61,3.53-4.58,6.94-3.82,7.62C88.62,354.82,91.23,353.54,91.78,353.29Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.52,349.49c15.56,14.11,18.94,36.73,16.54,56.75-.07.45-.77.35-.79-.07-.17-4.53-.2-9-.39-13.5-.09-.2-.16-.39-.25-.59-4-2.7-7.74-5.78-10.14-10.1-2.69-4.83-3.89-10.35-6-15.42-.2-.49.33-.36.68-.12,9.38,6.38,12.57,13.51,15.55,23.09a79.55,79.55,0,0,0-2.16-15c-2.32-9.11-6.56-18.06-13.42-24.62C54.89,349.65,55.25,349.24,55.52,349.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,351.31c-2.58.18-4,4.37-6,5.65a1.94,1.94,0,0,1-2.87-.34c-2.1-2.71.51-6.24,3-8.26-1.8.83-3.28,2.21-5.25,2.66a1.86,1.86,0,0,1-2.47-1.35c-1-3.76,3.68-5.63,6.94-5.83-1.63-1-6.27-3.86-3.92-5.42s7.87,2.51,9.66,3.85c2.63,2,5.78,5,6,8.18C58.18,354.22,54.79,352,52.77,351.31Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,351.31c-2.58.18-4,4.37-6,5.65a1.94,1.94,0,0,1-2.87-.34c-2.1-2.71.51-6.24,3-8.26-1.8.83-3.28,2.21-5.25,2.66a1.86,1.86,0,0,1-2.47-1.35c-1-3.76,3.68-5.63,6.94-5.83-1.63-1-6.27-3.86-3.92-5.42s7.87,2.51,9.66,3.85c2.63,2,5.78,5,6,8.18C58.18,354.22,54.79,352,52.77,351.31Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.54,351.91c-3.36-1.37-9.61,1-10.2-.2-1.19-2.5,3.81-4.44,6.53-4.88-2.54-.58-7.41-1.49-7.35-3.92.07-3,7.38-.7,11.14,2,4.74,3.35,4.84,6.76,4.1,7.47C56.76,353.32,54.09,352.14,53.54,351.91Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.54,351.91c-3.36-1.37-9.61,1-10.2-.2-1.19-2.5,3.81-4.44,6.53-4.88-2.54-.58-7.41-1.49-7.35-3.92.07-3,7.38-.7,11.14,2,4.74,3.35,4.84,6.76,4.1,7.47C56.76,353.32,54.09,352.14,53.54,351.91Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.43,386.76a152.87,152.87,0,0,0,4.83,22.31.56.56,0,0,0,1.09-.22c-1-6.87-2.89-13.62-3.91-20.5a103,103,0,0,1-1.19-21.05c.65-11.59,3.8-23.91,11.36-33,.17-.21-.19-.52-.36-.32-15.14,17.65-12.73,39.29-12.71,41.23-2.15-7.3-4.35-15.68-12.46-23.12-.35-.32-.62-.17-.56.38C59,366,62.73,373.12,70.59,380.36,70.81,382.51,71.09,384.65,71.43,386.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75,336.35c2.72-1.21,6.48,2.26,9.17,2.5a2.23,2.23,0,0,0,2.73-1.9c.67-3.89-3.9-6.08-7.53-6.78,2.29-.14,4.54.47,6.79-.13a2.16,2.16,0,0,0,1.78-2.72c-1-4.38-6.8-3.73-10.22-2.17,1.09-1.94,4.29-7.33,1-7.64s-6.65,6.81-7.75,9.15c-1.6,3.43-3.2,8.18-1.69,11.59C79.83,342.25,82.08,338.17,83.75,336.35Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.75,336.35c2.72-1.21,6.48,2.26,9.17,2.5a2.23,2.23,0,0,0,2.73-1.9c.67-3.89-3.9-6.08-7.53-6.78,2.29-.14,4.54.47,6.79-.13a2.16,2.16,0,0,0,1.78-2.72c-1-4.38-6.8-3.73-10.22-2.17,1.09-1.94,4.29-7.33,1-7.64s-6.65,6.81-7.75,9.15c-1.6,3.43-3.2,8.18-1.69,11.59C79.83,342.25,82.08,338.17,83.75,336.35Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.29,337.39c2.67-3.22,10.34-4.17,10.27-5.74-.15-3.19-6.28-2.45-9.29-1.42,2.27-2,6.73-5.54,5.35-8-1.68-3-7.89,3.29-10.27,8-3,6-1.25,9.51-.12,9.83C80.79,340.57,82.85,337.92,83.29,337.39Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.29,337.39c2.67-3.22,10.34-4.17,10.27-5.74-.15-3.19-6.28-2.45-9.29-1.42,2.27-2,6.73-5.54,5.35-8-1.68-3-7.89,3.29-10.27,8-3,6-1.25,9.51-.12,9.83C80.79,340.57,82.85,337.92,83.29,337.39Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.47,390.84l-6.67,51H95.42c-.83-4.52-8.4-51.07-8.4-51.07Z",
    style: {
      fill: "#FFBE0B"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Globe--inject-31"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.56,298.29a37.31,37.31,0,0,1-7.16,22h0a37.49,37.49,0,1,1-30.33-59.54c1,0,2.05,0,3.05.12a37.44,37.44,0,0,1,26.42,14.2,36.71,36.71,0,0,1,2.34,3.32A37.32,37.32,0,0,1,447.56,298.29Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.17,316c-.48,1.26.31,1.31.36,1.84s0,1.52-1.52,3.05-4,1.2-4.57,1.83-1.42,3.31-2.68,4.2-1.47.37-3.25.74-3.15,2.68-3.68,3.78.11,2.94-1.15,3-1.84-2.67-3-4.14a9.91,9.91,0,0,1-1.89-4.52c-.36-1.73.21-5.36,0-6.77s-4-3.94-5.35-5.68-3.26-5.2-3.15-6.35a4.66,4.66,0,0,1,1.57-2.89c.63-.47.37-.73.47-1.15s.63-.53.74-1.05a3.27,3.27,0,0,0-.84-2.37c-.53-.26-.89.63-1.21.48s-1.26-1.27-1.63-1.37-.26.68-.78-.32-.79-3.51-1.21-3.93-.74.73-1.74,0-1.41-2.16-1.83-2.37-1,.06-1.43-.78.38-2.37,0-2.21-1.2,1.37-1.41.21,1.05-5,.84-7.14a8.39,8.39,0,0,1,2-6.09s.21-1.16.42-1.89,4.72-3.68,5.25-4.52a4.05,4.05,0,0,0,.37-1.49,37.27,37.27,0,0,1,22.2-7.28c1,0,2.05,0,3.05.12a1.71,1.71,0,0,0,.11.14,4.34,4.34,0,0,0,2.28,1.44c1.33.49,1.64,1.12,1.36,1.64a1.34,1.34,0,0,1-1.26.67c-.52,0-1-.25-1.57.1s-1.13,2.24-1.86,2.35-2-1.68-2.31-2.21.63-1.64.2-2.17-1.18-.42-2.37-.52-4,.35-3.85.8,4.06-.07,4.16.84-2.9,2.45-3.43,2.31-1.22-1.05-2-1.15-1.4.52-1.89.59-1.05-.52-1.79-.38-.91.77-1.29,1-1.3.25-1.4.81,1.15.87,1.47,1.22-.39,1.55-.07,1.79,2.27-1.47,2.76-1.89.91-2.24,2-2.21,1.4,1.82,1.75,2,1.12-.42,2.28-.18,2,2.77,2.17,3.54.7,1.54.28,1.86a3,3,0,0,1-2.56-.7c-.24-.49,1.26-1.23,1.16-1.4a1.5,1.5,0,0,0-1.44-.15c-.45.27-.66.85-1.15,1s-1.79-1.33-2.14-.91.35,1.75.7,2.06,1.65.49,1.75.84-.87,1.12-2.06,1.05-2.17-1-2.63-.59-.21,1.4-.52,1.75-2,.1-2.87,1-1.23,2.28-2.07,3.05-1.23-.21-2.35.87-1.29,3.5-1.33,4.34,0,1.51-.28,1.4-.66-.84-.77-1.29.25-1.23.25-1.51a5,5,0,0,0-2.56-1.85c-.94-.14-1.78.63-2.48,1.19s-2,.45-2.42.91-.8,4.48-.45,5.43.8.94,1.92.45.49-1.44,1.16-1.23a1.58,1.58,0,0,1,1,1.47c0,.57-1.33,1.9-1.15,2.28s1.33-.07,1.89.11.84.52.66,2-.07,2.55.77,3,1.32-.68,1.68-.52.9,1,1.42.94.26-.52,1.26-.84.63-.52.84-1.15a1.15,1.15,0,0,1,1.53-.84c.68.31.21.79.26,1.31s1.26.58,2.2.89,1.47,0,3.36.63,2,2.53,2.79,2.84,3.41-.21,5.3,1.16,1.37,3.88,2.31,4.62,4.47,1.73,5.83,2,1.58-.68,2.68-.42a2.34,2.34,0,0,1,2.1,2.1C422.74,311.92,418.64,314.73,418.17,316Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,289.14c0,.3.91.42,2,1s1.43,2.34,2,2.31.39-.84.6-1.05a.68.68,0,0,0,0-1.12c-.56-.46-1.11-1.44-2.13-1.58s-1.2-.56-1.65-.53A.79.79,0,0,0,390,289.14Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.73,292.08c-.16.43,0,.74,1.12,1s2.17-.28,1.82-.51-.88-.12-.67-.51.14-.94-.77-.84S395.87,291.7,395.73,292.08Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.65,292.2c-.39.06-.6.72-.21,1.14s.38.35.84,0,1.15-.52,1-.87S400,292.14,399.65,292.2Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.69,293.63c.17-.52,1.05,0,1.44.55a2.28,2.28,0,0,1,0,2c-.21.6-.35,1.3-.84,1s0-1.12,0-1.61S402.55,294.06,402.69,293.63Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.78,264.42c-.18.44.67.6,1.16.88s.87.45,1.15,0a.77.77,0,0,0-.49-1.09C419.22,264.11,418,264,417.78,264.42Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.4,268.52c.32.34.87.28,1.26.77s.24,1.33.73,1.58.84,0,.88-.35-.7-1.23-.63-1.41,1,.25,1.22.78-.21,1.26.28,1.4.39-.49.6-.63.66-.07.63-.49a3.22,3.22,0,0,0-1.05-1.65,3.86,3.86,0,0,0-1.58-.84,2.29,2.29,0,0,0-1.89.28C424.47,268.27,424.2,268.31,424.4,268.52Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M439.54,275.12a.65.65,0,0,1-.19.37c-.74.52-1.61-1.3-2.63-1.65s-1.47-1.64-1.68-1.36-.14.66-.46,1.12-.77.35-1,1.22,1,2.49.71,3-.63.35-1.2.32-.45.45-1.18.24-.11-1.12-1.27-2.2-1.54-1.3-1.29-1.79-.11-1.19.42-1.26.94.7,1.29.91.81-.42.84-1-1.22-1.33-1.68-1.76a3.15,3.15,0,0,1-.31-2.34c.17-.31.7-.21.84-1,.08-.45-.63-1.2-1.24-1.75A37.44,37.44,0,0,1,439.54,275.12Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.77,306.5c.11-1.12-.45-1.19.11-3.25a6,6,0,0,0-1-4.73c-.42-.45-1.33-.31-2.06.14s-.21.81-.7,1-1-.1-1.44-.07-.87,1.19-1.85,1.16-1.61-1.44-2.35-2.44-2.24-1.62-2.73-2.85.45-3.11.24-4.55-1.15-1.12-1.33-1.92.14-.42.39-1.2-.28-1.19.21-2.52,1.36-2,1.15-2.59a10.07,10.07,0,0,1-.91-2.27c0-.7.67-.67,2-1.65s1.68-.91,2.7-.56a13.64,13.64,0,0,0,2.24.63c.59.11,1.4,1.65,1.64,1.58s.28-.53.39-1.19a1.5,1.5,0,0,1,.43-.76,37.53,37.53,0,0,1-1.48,41.9C444,314.89,444.67,307.62,444.77,306.5Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.17,298.29a42.68,42.68,0,0,0,1.21,11.47l.33,1.41.46,1.38.93,2.76,1.19,2.66c.21.44.39.89.62,1.32l.72,1.27a43.43,43.43,0,0,0,7,9.32l2.14,2c.7.69,1.53,1.22,2.29,1.84A47.93,47.93,0,0,0,389,337c.85.48,1.75.89,2.62,1.34l1.33.65c.44.21.91.36,1.37.54l2.77,1,2.85.76,1.43.38,1.46.24,2.92.47,3,.17,1.47.09c.5,0,1,0,1.48-.05l3-.13c1-.1,2-.28,2.94-.42a45.91,45.91,0,0,0,5.78-1.29c.94-.3,1.86-.66,2.8-1l1.39-.51c.45-.19.9-.42,1.34-.63l2.68-1.28,2.54-1.54a19.22,19.22,0,0,0,2.44-1.68c.78-.6,1.6-1.16,2.35-1.81a44.78,44.78,0,0,0,4.24-4.14,42.26,42.26,0,0,0,6.72-9.72l1.26-2.68c.38-.91.68-1.85,1-2.78l.5-1.39c.15-.47.25-1,.37-1.43l.72-2.87a46.89,46.89,0,0,0,.7-11.76,43.26,43.26,0,0,0-7.83-21.83,42.82,42.82,0,0,0-17.8-14.46,43.76,43.76,0,0,1,16.69,15.21,42.89,42.89,0,0,1,6.82,21.21,48.39,48.39,0,0,1-.92,11.14l-.72,2.7c-.13.45-.23.91-.38,1.35l-.49,1.31c-.34.86-.63,1.75-1,2.6l-1.23,2.5a22.35,22.35,0,0,1-1.38,2.43c-.5.78-.92,1.61-1.5,2.35a45.65,45.65,0,0,1-7.51,8.19c-.71.61-1.48,1.13-2.22,1.69l-1.12.83c-.38.27-.79.49-1.18.74-12.49,8.21-29.41,8.64-42.61,1.59a45.8,45.8,0,0,1-9.1-6.55,42.21,42.21,0,0,1-7.14-8.72l-.77-1.19c-.24-.41-.43-.84-.66-1.25l-1.3-2.53L370,312.26l-.52-1.32-.39-1.37c-.26-.92-.54-1.83-.78-2.75l-.5-2.82c-.09-.47-.19-.94-.26-1.41l-.13-1.43Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "425.13 264.36 430.21 266.77 433.78 256.07 431.17 254.83 425.13 264.36",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.77,
    y: 341.43,
    width: 5.45,
    height: 13.34,
    transform: "translate(818.98 696.2) rotate(180)",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 389.53,
    y: 349.81,
    width: 39.93,
    height: 4.95,
    transform: "translate(818.98 704.57) rotate(180)",
    style: {
      fill: "#37474f"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Books--inject-31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 346.13,
    y: 427.9,
    width: 114.9,
    height: 13.6,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.67,
    y: 427.9,
    width: 4.68,
    height: 13.6,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 436.28,
    y: 427.9,
    width: 11.23,
    height: 13.6,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.05,431.51l-2.75,3.57a.3.3,0,0,1-.24.13h0a.28.28,0,0,1-.25-.13L389,431.52v6.61a.28.28,0,0,1-.29.27.29.29,0,0,1-.31-.27v-7.45a.27.27,0,0,1,.12-.22l0,0a.31.31,0,0,1,.41.07l3.06,4,3-4a.31.31,0,0,1,.41-.07l.09.09a.53.53,0,0,1,.05.15v7.45a.29.29,0,0,1-.3.27.27.27,0,0,1-.29-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.67,436.32h-3.91l-.76,1.9a.3.3,0,0,1-.29.18h-.11a.29.29,0,0,1-.17-.37l3-7.45a.33.33,0,0,1,.3-.18.3.3,0,0,1,.29.18l3,7.45a.28.28,0,0,1-.16.37h-.11a.3.3,0,0,1-.28-.18Zm-3.69-.56h3.47l-1.73-4.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.88,430.92h-2.59a.28.28,0,0,1-.29-.28.29.29,0,0,1,.29-.28h5.76a.3.3,0,0,1,.3.28.29.29,0,0,1-.3.28h-2.58v7.21a.29.29,0,0,1-.3.27.28.28,0,0,1-.29-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.61,434.66H413.2v3.47a.29.29,0,0,1-.31.27.28.28,0,0,1-.29-.27v-7.49a.29.29,0,0,1,.29-.28.3.3,0,0,1,.31.28v3.47h4.41v-3.47a.3.3,0,0,1,.3-.28.29.29,0,0,1,.3.28v7.49a.28.28,0,0,1-.3.27.29.29,0,0,1-.3-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.13,
    y: 370.63,
    width: 114.9,
    height: 17.52,
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.72,382.12a.28.28,0,0,1,.38,0,4.87,4.87,0,0,0,2.82,1,3.37,3.37,0,0,0,1.88-.53,1.46,1.46,0,0,0,.74-1.19,1.27,1.27,0,0,0-.7-1.11,6.1,6.1,0,0,0-2-.65h0a5.64,5.64,0,0,1-2-.68,1.64,1.64,0,0,1-.88-1.4,1.85,1.85,0,0,1,.89-1.51,3.74,3.74,0,0,1,2.07-.58,4.9,4.9,0,0,1,2.65.93.24.24,0,0,1,.07.35.27.27,0,0,1-.37.07,4.45,4.45,0,0,0-2.35-.85,3.18,3.18,0,0,0-1.75.49,1.37,1.37,0,0,0-.68,1.1,1.19,1.19,0,0,0,.64,1,5.42,5.42,0,0,0,1.84.61h0a5.94,5.94,0,0,1,2.19.73,1.8,1.8,0,0,1,.94,1.52,2,2,0,0,1-1,1.61,3.94,3.94,0,0,1-2.2.63,5.53,5.53,0,0,1-3.17-1.16A.25.25,0,0,1,401.72,382.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.36,375.47a4.76,4.76,0,0,1,2.77.88.26.26,0,0,1,.05.4.3.3,0,0,1-.42.06,4.07,4.07,0,0,0-2.4-.78,3.53,3.53,0,1,0,0,7,3.78,3.78,0,0,0,2.38-.78.31.31,0,0,1,.43.07.26.26,0,0,1,0,.4,4.76,4.76,0,0,1-2.77.88,4.1,4.1,0,1,1,0-8.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.81,375.86a.29.29,0,0,1,.29-.28.3.3,0,0,1,.31.28v7.49a.3.3,0,0,1-.31.28.29.29,0,0,1-.29-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.46,375.86a.29.29,0,0,1,.29-.28h4.42a.29.29,0,1,1,0,.57h-4.11v3.18h3.59a.29.29,0,0,1,.29.29.28.28,0,0,1-.29.27h-3.59v3.17h4.11a.29.29,0,1,1,0,.57h-4.44a.28.28,0,0,1-.27-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.35,376.77v6.58a.3.3,0,0,1-.3.28.29.29,0,0,1-.29-.28V376a.27.27,0,0,1,.11-.31.32.32,0,0,1,.42.07l5.19,6.76v-6.55a.3.3,0,0,1,.3-.28.29.29,0,0,1,.3.28v7.41a.29.29,0,0,1-.3.28.32.32,0,0,1-.24-.11l0,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M444.25,375.47a4.76,4.76,0,0,1,2.77.88.27.27,0,0,1,.05.4.3.3,0,0,1-.42.06,4.07,4.07,0,0,0-2.4-.78,3.53,3.53,0,1,0,0,7,3.78,3.78,0,0,0,2.38-.78.3.3,0,0,1,.42.07.25.25,0,0,1,0,.4,4.76,4.76,0,0,1-2.77.88,4.1,4.1,0,1,1,0-8.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.61,375.86a.3.3,0,0,1,.3-.28h4.41a.29.29,0,1,1,0,.57h-4.11v3.18h3.59a.3.3,0,0,1,.3.29.29.29,0,0,1-.3.27h-3.59v3.17h4.11a.29.29,0,1,1,0,.57h-4.44a.28.28,0,0,1-.27-.28Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.8,
    y: 370.63,
    width: 28.88,
    height: 17.52,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.23,
    y: 373.08,
    width: 18.01,
    height: 3.08,
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.23,
    y: 377.85,
    width: 18.01,
    height: 3.08,
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.23,
    y: 382.63,
    width: 18.01,
    height: 3.08,
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.4,
    y: 388.14,
    width: 117.36,
    height: 17.97,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.81,
    y: 393.97,
    width: 28.19,
    height: 6.31,
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.13,397.13a3.73,3.73,0,1,1-3.72-3.49A3.62,3.62,0,0,1,446.13,397.13Z",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.35,393.06a.28.28,0,0,1,.29-.27h4.41a.28.28,0,0,1,.3.27.29.29,0,0,1-.3.29H347v3.18h3.59a.29.29,0,1,1,0,.57H347v3.17h4.1a.29.29,0,0,1,.3.29.28.28,0,0,1-.3.27h-4.44a.27.27,0,0,1-.26-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.23,394v6.59a.29.29,0,0,1-.58,0v-7.38a.26.26,0,0,1,.11-.31.31.31,0,0,1,.41.07l5.2,6.75v-6.55a.28.28,0,0,1,.29-.27.29.29,0,0,1,.31.27v7.42a.29.29,0,0,1-.31.27.29.29,0,0,1-.23-.1s0,0-.05-.05Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.45,397.21a.29.29,0,0,1-.31-.27.3.3,0,0,1,.31-.29h2.68a.29.29,0,0,1,.27.29v2.8a.33.33,0,0,1-.11.21,4.62,4.62,0,0,1-2.77.88,4.1,4.1,0,1,1,0-8.16,4.67,4.67,0,0,1,2.78.91.27.27,0,0,1,0,.39.33.33,0,0,1-.43,0,3.87,3.87,0,0,0-2.39-.78,3.53,3.53,0,1,0,0,7,4,4,0,0,0,2.27-.69v-2.37Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.12,400.83h0a.28.28,0,0,1-.29-.27v-7.5a.28.28,0,0,1,.29-.27.29.29,0,0,1,.31.27v7.21h4.11a.29.29,0,0,1,.3.29.28.28,0,0,1-.3.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.84,393.06a.29.29,0,0,1,.3-.27.28.28,0,0,1,.3.27v7.5a.28.28,0,0,1-.3.27.29.29,0,0,1-.3-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.1,399.33a.27.27,0,0,1,.38,0,4.91,4.91,0,0,0,2.82,1,3.4,3.4,0,0,0,1.89-.53,1.48,1.48,0,0,0,.73-1.2,1.26,1.26,0,0,0-.7-1.1,5.79,5.79,0,0,0-2-.66h0a5.59,5.59,0,0,1-2-.67,1.66,1.66,0,0,1-.88-1.41,1.84,1.84,0,0,1,.89-1.5,3.69,3.69,0,0,1,2.07-.59,5,5,0,0,1,2.65.93.26.26,0,0,1,.08.36.28.28,0,0,1-.37.07,4.48,4.48,0,0,0-2.36-.85,3.2,3.2,0,0,0-1.75.48,1.38,1.38,0,0,0-.67,1.1,1.14,1.14,0,0,0,.64,1,5.08,5.08,0,0,0,1.83.61h0a6,6,0,0,1,2.18.74,1.78,1.78,0,0,1,.94,1.51,2,2,0,0,1-1,1.61,4,4,0,0,1-2.21.63,5.53,5.53,0,0,1-3.16-1.16A.24.24,0,0,1,382.1,399.33Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.68,397.09h-4.42v3.47a.28.28,0,0,1-.3.27.29.29,0,0,1-.3-.27v-7.5a.29.29,0,0,1,.3-.27.28.28,0,0,1,.3.27v3.47h4.42v-3.47a.28.28,0,0,1,.29-.27.29.29,0,0,1,.31.27v7.5a.29.29,0,0,1-.31.27.28.28,0,0,1-.29-.27Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.53,
    y: 354.77,
    width: 59.29,
    height: 15.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.81,
    y: 354.77,
    width: 54.8,
    height: 15.86,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.53,
    y: 356.42,
    width: 59.29,
    height: 12.57,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.69,359q9.31-.12,18.63-.18l8.43-.06,18.64.06c6.21,0,2.21.09,8.42.18-6.21.09-2.21.15-8.42.19l-18.64.05-8.43-.05Q355,359.13,345.69,359Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.69,361.47q9.31-.14,18.63-.18l8.43-.06,18.64,0c6.21,0,2.21.1,8.42.19-6.21.09-2.21.15-8.42.18l-18.64.06-8.43-.06Q355,361.61,345.69,361.47Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.69,363.93q9.31-.12,18.63-.18l8.43-.05,18.64.05c6.21,0,2.21.1,8.42.18-6.21.09-2.21.16-8.42.19l-18.64.05-8.43-.05Q355,364.07,345.69,363.93Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.69,366.4q9.31-.13,18.63-.18l8.43-.06,18.64.06c6.21,0,2.21.09,8.42.18-6.21.09-2.21.15-8.42.18l-18.64.06-8.43-.06Q355,366.54,345.69,366.4Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.96,
    y: 354.77,
    width: 7.72,
    height: 15.86,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 446.6,
    y: 354.77,
    width: 5.19,
    height: 15.86,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 406.1,
    width: 66.77,
    height: 21.8,
    transform: "translate(829.08 834) rotate(180)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.45,
    y: 406.1,
    width: 50.7,
    height: 21.8,
    transform: "translate(711.61 834) rotate(180)",
    style: {
      fill: "#FFBE0B"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.15,
    y: 408.36,
    width: 66.77,
    height: 17.27,
    transform: "translate(829.08 834) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.6,422.09c-5.2.08-10.4.15-15.61.18l-15.61.05-15.61-.05c-5.21,0-10.41-.1-15.62-.18q7.82-.13,15.62-.19l15.61,0,15.61,0Q435.8,421.95,443.6,422.09Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.6,418.7c-5.2.08-10.4.15-15.61.18l-15.61.06-15.61-.06q-7.81,0-15.62-.18,7.82-.13,15.62-.19l15.61-.05,15.61.05Q435.8,418.57,443.6,418.7Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.6,415.31q-7.8.13-15.61.18l-15.61.06-15.61-.06q-7.81,0-15.62-.18,7.82-.13,15.62-.19l15.61-.05,15.61.05Q435.8,415.18,443.6,415.31Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M443.6,411.92q-7.8.13-15.61.18l-15.61.06-15.61-.06q-7.81,0-15.62-.18,7.82-.14,15.62-.19l15.61-.05,15.61.06Q435.8,411.79,443.6,411.92Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.53,
    y: 406.1,
    width: 9.49,
    height: 21.8,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Desk--inject-31"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "465.97 441.8 411.98 442.04 357.99 442.13 250 442.3 142.01 442.13 88.02 442.05 34.02 441.8 88.02 441.56 142.01 441.47 250 441.3 357.99 441.47 411.98 441.56 465.97 441.8",
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReliability1);
export default __webpack_public_path__ + "static/media/reliability1.452f5aac5d6a8723f96bca6ba7107f64.svg";
export { ForwardRef as ReactComponent };